import {filter, lazy} from './lang.js';

export const append = (list, x) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        let _x = lazy(x, ...args);
        _list.push(_x);
        return filter(true);
    };
};

export const sublist = (list, a,b) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            let _a = lazy(a, ...args);
            let _b = undefined;
            if (b) {
                _b = lazy(b, ...args);
            }
            return _list.slice(_a, Math.max(1, _b % _list.length));
        }
        return 0;
    };
};

export const vectorAdd = (...vecs) =>
    (... args) => {
        let _vecs = vecs;
        if (vecs.length === 1) {
            if (Array.isArray(vecs[0])) {
                _vecs = vecs[0];
            } else {
                _vecs = lazy(vecs[0], ...args);
            }
        }
        return _vecs.reduce(
            (acc, current) =>
                lazy(current, ...args).map(
                    (x,i) => x + acc[i % acc.length]),
            [0]);
    };

export const len = (list) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            return _list.length;
        }
        return 0;
    };
};
export const map = (list, fn) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        let _fn = fn;
        return _list.map(_fn);
    };
};

export const nth = (n, list) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        let _n = lazy(n, ...args);
        return _list[_n % _list.length];
    };
};

export const cdr = (list) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            return _list.slice(1);
        } else {
            return [];
        }
    };
};

export const car = (list) => {
    return (... args) => {
        let _list = lazy(list, ...args);
        if (_list) {
            return _list[0];
        } 
    };
};



